import React from "react";
import { Habit, Day } from "../types";
import { getLastUsageDate, getHabitColor } from "../utils/habitUtils";
import { StreakIndicator } from "./StreakIndicator";
import { colors } from "../colors";

interface HabitButtonProps {
  habit: Habit;
  days: Day[];
  selectedDay: string;
  greyOutEnabled: boolean;
  pressStartTime: number | null;
  pressScale: number;
  pressedItemId: number | null;
  onPressStart: (habit: Habit, event: React.MouseEvent | React.TouchEvent) => void;
  onPressMove: (event: React.MouseEvent | React.TouchEvent) => void;
  onPressEnd: (habit: Habit) => void;
  onPressCancel: () => void;
  onClick: (habit: Habit) => void;
}

export const HabitButton: React.FC<HabitButtonProps> = ({
  habit,
  days,
  selectedDay,
  greyOutEnabled,
  pressStartTime,
  pressScale,
  pressedItemId,
  onPressStart,
  onPressMove,
  onPressEnd,
  onPressCancel,
  onClick,
}) => {
  const isActive = days.find(day => day.date === selectedDay)?.habits.includes(habit.id);
  const habitColor = getHabitColor(habit.score, colors);

  return (
    <button
      onMouseDown={(e) => onPressStart(habit, e)}
      onMouseMove={onPressMove}
      onMouseUp={() => onPressEnd(habit)}
      onMouseLeave={onPressCancel}
      onTouchStart={(e) => onPressStart(habit, e)}
      onTouchMove={onPressMove}
      onTouchEnd={() => onPressEnd(habit)}
      onTouchCancel={onPressCancel}
      onClick={(e) => {
        if (pressStartTime) {
          e.preventDefault();
          return;
        }
        onClick(habit);
      }}
      style={{
        backgroundColor: isActive ? habitColor : "transparent",
        border: isActive ? `1px solid ${habitColor}` : "1px solid #ccc",
        borderRadius: "16px",
        padding: "10px 14px",
        margin: "5px",
        cursor: "pointer",
        color: isActive ? "#fff" : "#000",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        position: "relative",
        opacity: greyOutEnabled ? (getLastUsageDate(days, habit.id) > 30 ? 0.3 : getLastUsageDate(days, habit.id) > 10 ? 0.6 : 1) : 1,
        transform: pressedItemId === habit.id ? `scale(${pressScale})` : 'scale(1)',
        transformOrigin: "center",
        WebkitTapHighlightColor: "transparent",
        touchAction: "manipulation",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none"
      }}
    >
      {habit.name}
      <StreakIndicator 
        habit={habit} 
        days={days} 
        selectedDay={selectedDay} 
 
        isActive={isActive} 
      />
    </button>
  );
};